import { render, staticRenderFns } from "./ImportantOldListItem.vue?vue&type=template&id=0f2c9166&scoped=true&"
import script from "./ImportantOldListItem.vue?vue&type=script&lang=ts&"
export * from "./ImportantOldListItem.vue?vue&type=script&lang=ts&"
import style0 from "./ImportantOldListItem.vue?vue&type=style&index=0&id=0f2c9166&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2c9166",
  null
  
)

export default component.exports